import { apiPostAsUser } from './api_v2';
import db from './db';
import { storeDirectMessagePayload } from './direct_messages_store';

export async function openDirectMessageByKey(directMessageKey) {
  const normalizedKey = typeof directMessageKey === 'string' ? directMessageKey.trim() : '';
  if (!normalizedKey) return null;

  const response = await apiPostAsUser('/direct_messages', {
    direct_message: { direct_message_key: normalizedKey },
  });
  const data = await response.json();
  if (!(response.ok && data.ok && data.data?.direct_message)) return null;

  const directMessage = await storeDirectMessagePayload(data.data.direct_message);
  if (!directMessage?.id) return null;

  window.dispatchEvent(
    new CustomEvent('output:internal:update-route', {
      detail: { to: `~/messages/${directMessage.id}` },
    }),
  );
  return directMessage;
}

export async function openDirectMessageForWorkspaceProfile({ workspaceId, profileId }) {
  const normalizedWorkspaceId = typeof workspaceId === 'string' ? workspaceId.trim() : '';
  const normalizedProfileId = typeof profileId === 'string' ? profileId.trim() : '';
  if (!normalizedWorkspaceId || !normalizedProfileId) return null;

  const profile = await db.profiles.get([normalizedWorkspaceId, normalizedProfileId]);
  if (!profile || profile.role === 'deactivated') return null;

  return openDirectMessageByKey(profile.direct_message_key);
}
